import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { AppConfig } from '../../appconfig';
import { inject } from '@angular/core';

const retryCount = 3;
const retryDelay = 1500;

export function refreshTokenRetryInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn)
  : Observable<HttpEvent<unknown>> {

  const config = inject(AppConfig);
  const externalIdentityUri = config.CONFIG.externalIdentityUri;

  const tenantEndpoint = externalIdentityUri.substring(0, externalIdentityUri.lastIndexOf('/'));
  const tokenEndpoint = `${tenantEndpoint}/oauth2/v2.0/token`;

  if(req.url === tokenEndpoint){
    return next(req).pipe(
      retry({
        count: retryCount,
        delay: retryDelay
      })
    )
  } else {
    return next(req);
  }
}
